export default {
  empresa(state) {
    return state.empresa;
  },
  centroCusto(state) {
    return state.centroCusto;
  },
  produto(state) {
    return state.produto;
  },
  projeto(state) {
    return state.projeto;
  },
  responsavel(state) {
    return state.responsavel;
  },
  grupo(state) {
    return state.grupo;
  },
  fornecedor(state) {
    return state.fornecedor;
  },
  solicitante(state) {
    return state.solicitante;
  },
  tipoProduto(state) {
    return state.tipoProduto;
  },
  filtersState(state) {
    return {
      empresa: state.empresa,
      centroCusto: state.centroCusto,
      produto: state.produto,
      projeto: state.projeto,
      responsavel: state.responsavel,
      grupo: state.grupo,
      fornecedor: state.fornecedor,
      solicitante: state.solicitante,
      tipoProduto: state.tipoProduto,
    };
  },
  hasCustomFilters(state) {
    return [
      state.empresa,
      state.tipoProduto,
      state.responsavel && state.responsavel.length,
      state.produto && state.produto.length,
      state.centroCusto && state.centroCusto.length,
      state.projeto && state.projeto.length,
      state.grupo && state.grupo.length,
      state.fornecedor && state.fornecedor.length,
      state.solicitante && state.solicitante.length,
    ].some(v => !!v);
  },
};
